export default class Field {
	constructor({ id, label, choices }, idForm) {
		this._id = id;
		this._label = label;
		this._choices = choices;
		this._idForm = parseInt(idForm);
	}

	id() {
		return this._id;
	}

	label() {
		return this._label;
	}

	choices() {
		return this._choices || null;
	}

	idForm() {
		return this._idForm;
	}
}
